import { UntypedFormBuilder } from '@angular/forms';
import { HttpClient, HttpXsrfTokenExtractor } from '@angular/common/http';
import {
    Component,
    ChangeDetectorRef,
    Input,
    OnInit,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChanges,
    DestroyRef,
    inject
} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {FileUploaderOptions} from "ng2-file-upload/file-upload/file-uploader.class";
import {FileItem} from "ng2-file-upload/file-upload/file-item.class";
import {TranslateService} from "@ngx-translate/core";
import { LanguageService, FormService, CodescService} from '@signature-it/ngx-generic/services';
import { CngDataDTO, FileUploadField } from '@signature-it/ngx-generic/models';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';
import { FileUploaderCustom } from '@signature-it/ngx-generic/classes';
import * as mime from 'mime';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

declare var _: any;
const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';

@Component({
    selector: 'file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false
})

export class FileUploadComponent implements OnInit, OnChanges {

    protected route: ActivatedRoute = inject(ActivatedRoute);

    @Input() field: FileUploadField;
    @Input() value;
    @Input() viewMode;
    @Input() fieldControl;
    media: {};
    uploader:FileUploaderCustom;
    hasBaseDropZoneOver:boolean;
    hasAnotherDropZoneOver:boolean;
    response:string;
    open:boolean=false;
    urlRemoveItem:string =`${this.restUrlsConf.appURL}/public/product/deleteMediaAssets.json`;
    cngData: CngDataDTO;
    errorMessage: string = '';
    mimeTypeArray: string[] = [];
    extensionArray: string[] = [];
    @Input() immediateUpload = true;
    @Output() onUpdateUploaderQueue = new EventEmitter();
    _uploaderUrl: string;
    filename
    previewSrc;
    destroyRef = inject(DestroyRef);
    now = Date.now();
    pid: any;
    private tokenExtractor: HttpXsrfTokenExtractor = inject(HttpXsrfTokenExtractor);

    get uploaderUrl(): string {
        return this._uploaderUrl;
    }
    @Input() set uploaderUrl(value: string) {
        this._uploaderUrl = value || `${this.restUrlsConf.appURL}/public/product/uploadsMediaAssets.json`;
    }

    constructor(protected fb: UntypedFormBuilder,
                protected langSvc: LanguageService,
                protected FormSvc: FormService,
                protected http: HttpClient,
                private changeDetector: ChangeDetectorRef,
                protected restUrlsConf: RestUrlsConfig,
                protected codescSvc: CodescService,
                protected translateSvc: TranslateService,
                protected cd: ChangeDetectorRef) {
        this.subscribeCng();
        this.route.queryParams.subscribe(params => {
            if (params && params['edit']) {
                this.pid = params['edit'];
            }
        });
    }

     ngOnInit() {
        if(this.field) {
            this.setUploader();
        }
        this.hasBaseDropZoneOver = false;
        this.hasAnotherDropZoneOver = false;
        this.response = '';
        this.fieldControl?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value => {
           if(isNaN(value)) {
              this.media = null;
           } else {
               this.getMediaData(value);
               this.uploader?.clearQueue();
           }
        })
    }
    ngOnChanges(changes: SimpleChanges) {
        if(changes['value']) {
            if(isNaN(this.value)) {
                this.media = null;
            } else {
                this.getMediaData(this.value);
                this.uploader?.clearQueue();
            }
        }
    }


    getMediaData(value) {
        if(value){
            this.media = null;
            this.FormSvc.getMediaData(Number.parseInt(value)).pipe().subscribe(res => {
                this.media = res;
                this.cd.detectChanges();
            })
        }
    }

     async setUploader(){
        let self = this;
        this.mimeTypeArray = this.field?.allowedMimeType ? this.field.allowedMimeType.split(',') : [];
        if( this.mimeTypeArray.length < 1 ){
           let subjects = await self.getMimetypeFromCodesc();
            _.forEach(subjects, function(value) {
                self.extensionArray.push(String(value['value']));
                self.mimeTypeArray.push(String(value['additional_value']));
            });
        }else{
            this.extensionArray = this.mimeTypeArray.map( value => {
                return mime.getExtension(value);
            });
        }
        this.immediateUpload = this.field.immediateUpload;
        this.changeDetector.detectChanges();

         const cookieHeaderName = 'X-XSRF-TOKEN';
         const token = this.tokenExtractor.getToken();
         const header = token !== null ? [{ name:cookieHeaderName, value: token }] : [];

        let fileUploaderOptions : FileUploaderOptions = {
            url: this.uploaderUrl ,
            method: 'POST',
            headers : header
        };
        if (this.field.queueLimit) {
            fileUploaderOptions.queueLimit = this.field.queueLimit
        }
        this.uploader = new FileUploaderCustom(fileUploaderOptions);

        this.uploader.onBeforeUploadItem = (item: FileItem) => {
            if (this.immediateUpload) {
                this.uploader.options.additionalParameter = {
                    pid: this.cngData.product.id != -1 ? this.cngData.product.id : this.pid,
                    image_type: item._file.type,
                    questionId: this.field.questionId,
                    fieldName: this.field.key,
                    saveToScreenAssetLibrary: this.field.saveToScreenAssetLibrary
                };
            }
            this.onUpdateUploaderQueue.emit({event: FileUploadField.ON_BEFORE_UPLOAD_ITEM_EVENT, uploader: this.uploader, item, key: this.field.key});

        };


        this.uploader.onAfterAddingFile = (item: FileItem) => {
            // if(!this.field.extendedControl && this.uploader?.queue && this.uploader.queue.length > 1) {
            //     this.uploader.queue = [this.uploader.queue.pop()];
            // }
            this.errorMessage = '';
            item.alias = this.field.key;
            if (this.immediateUpload) {
                item.upload();
            }
            this.onUpdateUploaderQueue.emit({event: FileUploadField.ON_AFTER_ADDING_FILE_EVENT, uploader: this.uploader, item, key: this.field.key});
            this.previewFile(item);
        };

        this.uploader.onCancelItem = (item, response, status, headers) => {
            this.onUpdateUploaderQueue.emit({event: FileUploadField.ON_CANCEL_ITEM_EVENT, uploader: this.uploader, item, response, status, headers, key: this.field.key});
        }


        this.uploader.onCompleteItem = (item: FileItem, response: any, status: any, headers: any) => {
            if (this.immediateUpload) {
                response = response.slice(1,-1);
                item.index = Number(response)?Number(response):0;
                if(item.isError){
                    alert('failed to upload');
                } else {
                    this.onUpdateUploaderQueue.emit({event: FileUploadField.ON_COMPLETE_ITEM_EVENT, item, response, status, headers, key: this.field.key});
                }
            }
        };

        this.uploader.onWhenAddingFileFailed = (item: any, filter: any, options: any) => {
            switch (filter.name) {
                case 'mimeType':
                   this.errorMessage = this.translateSvc.instant('Type is not allowed.');
                    break;
                case 'queueLimit':
                   this.errorMessage = this.translateSvc.instant('The quantity of files is limited');
                    break;
                default:
                    this.errorMessage = this.translateSvc.instant('Unknown error');
            }
        };
    }

    async getMimetypeFromCodesc() {
        return this.codescSvc.getDataByVar('ma_mime_type_var').toPromise();
    }


    removeFile(item?) {
        if(item?.isUploaded && !item?.isError){
            this.deleteFileFromServer(item.index);
        }
        if (this.uploader?.queue?.length) {
            this.uploader.removeFromQueue(item);
        }
        if (!item) {
            this.field.value = '';
        }
        this.onUpdateUploaderQueue.emit({uploader: this.uploader, key: this.field.key});
    }

    deleteFileFromServer(mediaId) {
        if (this.immediateUpload) {
            const path = `&media_id=`+mediaId;
            this.http.get(`${this.urlRemoveItem}?${path}`).subscribe(res => {});
        }
    }

    clearQueue(){
        this.uploader.queue.forEach( (item) => {
            if(item.index) this.deleteFileFromServer(item.index);
        });
        this.uploader.clearQueue();
        this.onUpdateUploaderQueue.emit({event: FileUploadField.ON_CLEAR_QUEUE_EVENT, uploader: this.uploader, key: this.field.key});
    }

    subscribeCng() {
        this.FormSvc.cngData$.subscribe(cngData => {
            this.cngData = cngData;
        });
    }

    public fileOverAnother(e:any):void {
        this.hasAnotherDropZoneOver = e;
    }

    previewFile(selectedFile): void {
        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = (e) => {
                // Access the result property of FileReader
                selectedFile.previewSrc = e.target?.result;
            };
            reader.readAsDataURL(selectedFile._file);
        }
    }


}
